import React, { useContext } from 'react';

import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import type { TRectangleContentItem } from '@src/types/wysiwyg_editor';
import type { ReactRefT } from '@src/types/misc';

type TProps = {
  data: TRectangleContentItem;
  backgroundColor?: string;
  elRef?: ReactRefT<SVGRectElement>;
  location: {
    x: number;
    y: number;
  };
  opacity?: number;
  height: number;
  width: number;
};

const defaultBackgroundColor = '#000000';

function opacity(possibleValue) {
  if (possibleValue === null || typeof possibleValue === 'undefined') {
    return 1;
  }

  return possibleValue;
}

function Rectangle(props: TProps) {
  const { viewbox } = useContext(WysiwygEditorStateContext);

  return (
    <g>
      <rect
        x={props.location.x * viewbox.width}
        y={props.location.y * viewbox.height}
        height={props.height * viewbox.height}
        width={props.width * viewbox.width}
        fill={props.backgroundColor || defaultBackgroundColor}
        opacity={opacity(props.opacity)}
        ref={props.elRef}
      />
    </g>
  );
}

export default Rectangle;
